import React, {Component} from "react";
import {connect} from "react-redux";
import {Field, reduxForm, submit, formValueSelector} from "redux-form/immutable";
import ActionButton from "../../ActionButton";
import FormFieldsTable from "../../forms/FormFieldsTable";
import TextInputField from "../../forms/TextInputField";
import {Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {cancelRegisterWarehouse, registerWarehouse} from "../../../actions/InventoryApiActions";
import {getSubmitInfoForCommand} from "../../../reducers/inventoryReducer";
import {isSubmitting, submitLabel} from "../../../lib/CommandStatus";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "id");
  errors = validatePresence(errors, values, "location");
  errors = validatePresence(errors, values, "company");
  errors = validatePresence(errors, values, "contact_name");
  return errors.toJS();
}

class RegisterWarehouseForm extends Component {

  render() {
    let {handleSubmit, submit, submitInfo} = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Warehouse"
              name="id"
              component={TextInputField}
              />
            <Field 
              label="Location"
              name="location"
              component={TextInputField}
              />
            <Field 
              label="Company or Name"
              name="company_name"
              component={TextInputField}
              />
            <Field
              label="Contact Name"
              name="contact_name"
              component={TextInputField}
              />
            <Field
              label="Telephone"
              name="contact_phone"
              component={TextInputField}
              />
            <Field
              label="Email"
              name="contact_email"
              component={TextInputField}
              />
          </FormFieldsTable>
        </div>
        <div className="buttons">
          <ActionButton label={submitLabel(submitInfo, "Submit")} onClick={submit} active={!isSubmitting(submitInfo)} />
          <ActionButton label="Cancel" active={!isSubmitting(submitInfo)} onClick={this.props.cancelRegisterWarehouse} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "RegisterWarehouseForm",
  validate: validateForm
})(RegisterWarehouseForm);

const selector = formValueSelector('RegisterWarehouseForm')
const ConnectedForm = connect(
  (state, ownProps) => ({
    submitInfo: getSubmitInfoForCommand(state.get("inventory"), "RegisterWarehouse"),
    countryValue: selector(state, "address.country_code")
  }),
  {
    cancelRegisterWarehouse,
    submit,
    onSubmit: (data) => registerWarehouse(data, "RegisterWarehouseForm")
  }
)(ReduxForm);

export default ConnectedForm;